import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PROJECTS, PROJECT_VIEWS } from "../keys";
import { format } from "date-fns";

const useProjectViews = (params) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const projectId = params[0];

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [PROJECTS, PROJECT_VIEWS, tenant.id, projectId, startDate, endDate],
    queryFn: () => ApiService.getProjectViews(since, until, projectId),
    select: (data) => data.data.graphs,
    placeholderData: { data: { graphs: [] } },
    enabled,
  });
};

export default useProjectViews;
